module.exports = __webpack_public_path__ + "media/images/landing/ar/main-8f2ecc70982840e7607f28501d295179.png";